import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysDefault$iterator$1Class;
function HashMapKeysDefault$iterator$1() {
  if (HashMapKeysDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.ha_1 = $entryIterator;
      }
      v1() {
        return this.ha_1.v1();
      }
      w1() {
        return this.ha_1.w1().r3();
      }
      u6() {
        return this.ha_1.u6();
      }
    }
    initMetadataForClass($);
    HashMapKeysDefault$iterator$1Class = $;
  }
  return HashMapKeysDefault$iterator$1Class;
}
var HashMapKeysDefaultClass;
function HashMapKeysDefault() {
  if (HashMapKeysDefaultClass === VOID) {
    class $ extends AbstractMutableSet() {
      static b8(backingMap) {
        var $this = this.g8();
        $this.a8_1 = backingMap;
        return $this;
      }
      ia(element) {
        throw UnsupportedOperationException().f1('Add is not supported on keys');
      }
      n2(element) {
        return this.ia((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      f5() {
        return this.a8_1.f5();
      }
      n9(element) {
        return this.a8_1.x4(element);
      }
      y2(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.n9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      u1() {
        var entryIterator = this.a8_1.q3().u1();
        return new (HashMapKeysDefault$iterator$1())(entryIterator);
      }
      v2() {
        return this.a8_1.v2();
      }
      t6() {
        return this.a8_1.t6();
      }
    }
    initMetadataForClass($, 'HashMapKeysDefault');
    HashMapKeysDefaultClass = $;
  }
  return HashMapKeysDefaultClass;
}
var HashMapValuesDefault$iterator$1Class;
function HashMapValuesDefault$iterator$1() {
  if (HashMapValuesDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.ja_1 = $entryIterator;
      }
      v1() {
        return this.ja_1.v1();
      }
      w1() {
        return this.ja_1.w1().s3();
      }
      u6() {
        return this.ja_1.u6();
      }
    }
    initMetadataForClass($);
    HashMapValuesDefault$iterator$1Class = $;
  }
  return HashMapValuesDefault$iterator$1Class;
}
var HashMapValuesDefaultClass;
function HashMapValuesDefault() {
  if (HashMapValuesDefaultClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static e8(backingMap) {
        var $this = this.r6();
        $this.d8_1 = backingMap;
        return $this;
      }
      x9(element) {
        throw UnsupportedOperationException().f1('Add is not supported on values');
      }
      n2(element) {
        return this.x9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      w9(element) {
        return this.d8_1.y4(element);
      }
      y2(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.w9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      u1() {
        var entryIterator = this.d8_1.q3().u1();
        return new (HashMapValuesDefault$iterator$1())(entryIterator);
      }
      v2() {
        return this.d8_1.v2();
      }
      t6() {
        return this.d8_1.t6();
      }
    }
    initMetadataForClass($, 'HashMapValuesDefault');
    HashMapValuesDefaultClass = $;
  }
  return HashMapValuesDefaultClass;
}
//region block: exports
export {
  HashMapKeysDefault as HashMapKeysDefaultd8xopyn6vbgh,
  HashMapValuesDefault as HashMapValuesDefault3j1xghpfb6bpq,
};
//endregion

//# sourceMappingURL=HashMapEntryDefault.mjs.map
